import React, {useState} from 'react';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import {t} from "react-switch-lang";
import AddIcon from './img/plus.png';
import './Modals.css';
import returnTitle from "./ModalData/Title";
import modalBody from "./ModalData/ModalBody";

export function Add(props) {
    const [modal, setModal] = useState(false);
    const userModal = () => setModal(!modal);

    const body = () => {
        const MyComponent = modalBody(props.id).add;
        if (MyComponent !== null) {
            return <MyComponent toggleModal={() => setModal(false)}
                                setRowChanged={() => props.setRowChanged()}/>
        } else {
            return ''
        }
    };

    return (
        <div className="add-btn">
            <Button className="add modal-open-button" onClick={userModal}>
                <img src={AddIcon} alt="icon"/>
               <b> {t('buttons.addBtn')}
                <span>  {returnTitle(props.id).toLowerCase()}</span></b>
            </Button>
            <Modal isOpen={modal} toggle={userModal} className="modal-lg"
                   backdrop="static">
                <ModalHeader toggle={userModal}>
                    <b>{t('buttons.addBtn')}
                        <span>    {returnTitle(props.id).toLowerCase()}</span>
                    </b>
                </ModalHeader>
                <ModalBody>
                    {body()}
                </ModalBody>
            </Modal>
        </div>
    );
}
